const accountInfo = {
  accountInfo: {
    account_information: 'Mijn accountgegevens',
    services: 'Mijn diensten',
    data_privacy: 'Mijn gegevens & privacy',
    benefits: 'Voordelen',
    company: 'Bedrijfsprofiel',
    branches: 'Vestigingen',
    users: 'Gebruikers',
    area_coverage: 'Servicegebieden',
    lead_program: 'Leads Voorkeuren',
    ein_program: 'Leads en Enphase installatienetwerk',
    request_system_access: 'Systeemtoegang aanvragen',
    ac_module_admin: 'AC Module Administratie',
    training_dashboard: 'Opleiding',
    enphase_store: 'Enphase Store',
    product_warranty_extension: 'Uitbreiding van de productgarantie',
    lpp: 'Programma voor arbeidsbescherming',
    permit_assistance: 'Bijstand bij het verlenen van vergunningen',
    incentive_programs: "incentive-programma's",
    ein_merchandise: 'EIN Merchandise',
    evse_incentives_tool: 'Tool voor kortingen en stimulansen voor EV-laders',
    financing: 'Financiering',
    training: 'Opleiding',
    authorized_subcontractor: 'Bevoegde onderaannemer',
    collaterals: 'Collaterals',
    my_leads: 'Mijn Leads',
    lead_details: 'Offerteaanvraag Details',
    api_access: 'API-toegang',
    third_party: 'Rapportage door derden',
    profiles: 'Rasterprofielen',
    createBranch: 'Filiaal toevoegen',
    branch_profile: 'Filiaalprofiel',
    new: 'Nieuw',
    applications: 'Toepassingen',
    createUser: 'Nieuwe gebruiker toevoegen',
    user_profile: 'Gebruikersprofiel',
    platform_discounts: 'Platform voor Kortingen',
    account_details: 'Accountgegevens',
    preferences: 'Voorkeuren',
    change_password: 'Wijzig wachtwoord',
    account: 'Rekening',
    dashboard: 'Dashboard',
    systems: 'Systemen',
    admin: 'Admin',
    einDashboard: 'EIN Dashboard',
    einAdmin: 'EIN Admin',
    edit: 'Bewerk',
    failureMessage: 'Er is iets misgegaan, probeer het alsjeblieft nog eens.',
    rma_dashboard: 'RMA Dashboard',
    generator_tokens: 'Tokens generator',
    data_plan_extension: 'Mobiele Connectie Gegevensuitbreiding',
    enphase_community: 'Enphase Community',
    enphase_support: 'Enphase-ondersteuning',
    whats_new: "Wat is er nieuw?"
  },
  buttons: {
    back: 'Terug naar'
  }
};

export default accountInfo;
